import { cn } from "@/lib/utils"
import type { ImgHTMLAttributes } from "react"

import LogoDark from "@/assets/logo/Logo=dark.svg"
import LogoLight from "@/assets/logo/Logo=light.svg"

export default function AppLogoIcon(
  props: ImgHTMLAttributes<HTMLImageElement>,
) {
  const { className, ...restProps } = props

  return (
    <>
      <img
        src={LogoLight}
        alt="Logo"
        className={cn("dark:hidden", className)}
        {...restProps}
      />
      <img
        src={LogoDark}
        alt="Logo"
        className={cn("hidden dark:block", className)}
        {...restProps}
      />
    </>
  )
}
